import React from "react";
import formItemLayout from "../../const/form/formItemLayout";
import { Form, Input, Icon } from 'antd';

function SimpleInput({ data, setData, handleInput, label, required = false,
    inputName, placeholder, width,addonBefore = "", addonAfter = "", type
}){
    if(type === "password"){
        return (
            <Form.Item 
                {...formItemLayout} 
                label={label} 
                style={{marginTop: 25}}
                hasFeedback 
                required={required ? required : false} 
            >
                <Input.Password 
                    value={data[inputName]} 
                    onChange={e => handleInput(e, "", data, setData)} 
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                    placeholder={placeholder}
                    style={{width: "80%"}}
                    name={inputName}
                />
            </Form.Item>
        )
    }else{
        return(
            <Form.Item 
                {...formItemLayout} 
                label={label} 
                style={{marginTop: 10}}
                hasFeedback
                required={required}
            >
                <Input 
                    addonBefore={addonBefore}
                    value={data[inputName]} 
                    placeholder={placeholder}
                    name={inputName}
                    style={ (width ? width : { width: "80%" } ) }
                    onChange={e => handleInput(e, "", data, setData)}
                    addonAfter={addonAfter}
                />
            </Form.Item>
        )
    }
}

export default SimpleInput;


// WEBPACK FOOTER //
// ./src/components/common/SimpleInput.jsx